import { defineMessages } from 'react-intl';

export default defineMessages({
    baseCoverages: {
        id: 'quoteandbind.farm.directives.HoOfferingSelection.defaultBaseCoverages.General Coverages',
        defaultMessage: 'General Coverages',
    },
    additionalCoverages: {
        id: 'quoteandbind.farm.directives.HoOfferingSelection.defaultAdditionalCoverages.Additional Coverages',
        defaultMessage: 'Additional Coverages',
    },

    liablityLineCoverages: {
        id: 'quoteandbind.farm.directives.HoOfferingSelection.defaultLiabilityLineCoverages.Liability Line Coverages',
        defaultMessage:'Liability Line Coverages',
    
    },
    packageSpecificCoverages: {
        id: 'quoteandbind.farm.directives.HoOfferingSelection.defaultPackageSpecificCoverages. Package-Specific Coverages',
        defaultMessage:'Package-Specific Coverages',
    },
    farmGenerateQuoteDocument: {
        id: 'quoteandbind.farm.directives.Generate Quote Document',
        defaultMessage: 'Generate Quote Document',
    },
    farmGenerateQuoteDocumentConf: {
        id: 'quoteandbind.farm.directives.Are you sure you want to generate quote document',
        defaultMessage: 'Are you sure you want to generate quote document',
    }

});
